/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { HexRowFragmentDoc } from "./HexRow.generated";
export type HexListFragment = {
  readonly __typename: "Hex";
  readonly id: c.HexId;
  readonly userUpdatedDate: c.DateTimeString;
  readonly trashDate: c.DateTimeString | null;
  readonly title: string;
  readonly description: c.RichTextDocument | null;
  readonly canShare: boolean;
  readonly maxGrantableRole: Types.ProjectRole | null;
  readonly canViewLogic: boolean;
  readonly effectiveRole: Types.ProjectRole | null;
  readonly starredByViewer: boolean;
  readonly hexType: Types.HexType;
  readonly projectLanguage: Types.ProjectLanguage;
  readonly canDelete: boolean;
  readonly canSetOwner: boolean;
  readonly canEdit: boolean;
  readonly canEditorsShare: boolean;
  readonly archivedDate: c.DateTimeString | null;
  readonly unarchivedDate: c.DateTimeString | null;
  readonly publicRoleV2: Types.ProjectRole | null;
  readonly organizationRoleV2: Types.ProjectRole | null;
  readonly grantSummary: c.ProjectGrantSummary;
  readonly onlyGrantedToCurrentUser: boolean;
  readonly totalViewCount: number;
  readonly currentDraft: {
    readonly __typename: "HexVersion";
    readonly id: c.HexVersionId;
    readonly createdDate: c.DateTimeString;
    readonly title: string;
    readonly logicSessionId: c.AppSessionId;
    readonly canEdit: boolean;
    readonly denialReason:
      | {
          readonly __typename: "AssetAccess";
          readonly hasAccessToSharedDataConnections: boolean;
          readonly hasAccessToSharedFiles: boolean;
          readonly hasAccessToSharedPackages: boolean;
          readonly hasAccessToSharedSecrets: boolean;
          readonly hasAccessToSharedSyncRepositories: boolean;
        }
      | { readonly __typename: "MissingProjectRole" }
      | null;
  };
  readonly creator: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly name: string | null;
    readonly email: string;
  };
  readonly status: {
    readonly __typename: "Status";
    readonly id: c.StatusId;
    readonly name: string;
    readonly color: Types.HexColor;
    readonly description: string | null;
    readonly inLibrary: boolean;
    readonly endorsed: boolean;
    readonly icon: Types.IconType | null;
  } | null;
  readonly categories: ReadonlyArray<{
    readonly __typename: "Category";
    readonly id: c.CategoryId;
    readonly name: string;
    readonly color: Types.HexColor;
    readonly description: string | null;
  }>;
  readonly lastPublishedVersion: {
    readonly __typename: "HexVersion";
    readonly id: c.HexVersionId;
  } | null;
  readonly owner: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly name: string | null;
    readonly email: string;
  };
  readonly org: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly displayName: string;
    readonly allowPublicSharing: boolean;
    readonly resolvedAllowPublicSharing: boolean;
  };
  readonly projectAnalytics: {
    readonly __typename: "HexAnalytics";
    readonly id: c.HexAnalyticsId;
    readonly totalViewsLast7Days: number;
    readonly totalViewsLast14Days: number;
    readonly totalViewsLast30Days: number;
  };
};

export const HexListFragmentDoc = /*#__PURE__*/ gql`
  fragment HexListFragment on Hex {
    id
    userUpdatedDate
    trashDate
    currentDraft {
      id
      createdDate
    }
    creator {
      id
      name
    }
    ...HexRowFragment
  }
  ${HexRowFragmentDoc}
`;
